import { render, staticRenderFns } from "./skeleton-item.vue?vue&type=template&id=674c8bf2&scoped=true&lang=pug&"
import script from "./skeleton-item.vue?vue&type=script&lang=js&"
export * from "./skeleton-item.vue?vue&type=script&lang=js&"
import style0 from "./skeleton-item.vue?vue&type=style&index=0&id=674c8bf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c8bf2",
  null
  
)

export default component.exports